 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A780802149541 from '@/components/9780802149541'
 import A7808021495411 from '@/components/97808021495411'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import A7808021495412 from '@/components/97808021495412'
 import A7808021495413 from '@/components/97808021495413'
 import A7808021495414 from '@/components/97808021495414'
 import A7808021495415 from '@/components/97808021495415'
 import A7808021495416 from '@/components/97808021495416'
 import A7808021495417 from '@/components/97808021495417'
 import A7808021495418 from '@/components/97808021495418'
 import A7808021495419 from '@/components/97808021495419'
 import A78080214954110 from '@/components/978080214954110'
 import A78080214954111 from '@/components/978080214954111'
 import A78080214954112 from '@/components/978080214954112'
 import A78080214954113 from '@/components/978080214954113'
 import A78080214954114 from '@/components/978080214954114'
 import LOVE_2 from '@/components/love_2'
 import A78080214954115 from '@/components/978080214954115'
 import A78080214954116 from '@/components/978080214954116'
 import A78080214954117 from '@/components/978080214954117'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/9780802149541",
 			"name" : "9780802149541",
 			"component" : A780802149541
 		},
 		{
 			"path" : "/97808021495411",
 			"name" : "97808021495411",
 			"component" : A7808021495411
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/97808021495412",
 			"name" : "97808021495412",
 			"component" : A7808021495412
 		},
 		{
 			"path" : "/97808021495413",
 			"name" : "97808021495413",
 			"component" : A7808021495413
 		},
 		{
 			"path" : "/97808021495414",
 			"name" : "97808021495414",
 			"component" : A7808021495414
 		},
 		{
 			"path" : "/97808021495415",
 			"name" : "97808021495415",
 			"component" : A7808021495415
 		},
 		{
 			"path" : "/97808021495416",
 			"name" : "97808021495416",
 			"component" : A7808021495416
 		},
 		{
 			"path" : "/97808021495417",
 			"name" : "97808021495417",
 			"component" : A7808021495417
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js